import type { FC } from 'react';
import Tooltip from '@components/Tooltip';
import { sidebarSectionTitleClasses } from '@ContractBuilder/components/shared-sidebar';

interface SectionTitleProps {
  title: string;
  isDimmed: boolean;
}

export const SectionTitle: FC<SectionTitleProps> = ({ title, isDimmed }) => {
  return (
    <Tooltip content={title}>
      <span className={sidebarSectionTitleClasses({ disabled: isDimmed })} title={title}>
        {title}
      </span>
    </Tooltip>
  );
};
